module.exports = __webpack_public_path__ + "static/img/jiankang.f663346.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/jiankang.png
// module id = BIXw
// module chunks = 1